import React from 'react';
import {
  LocationFiltersType,
  OnQueryInputChangeType,
  ProviderFiltersType,
  SetControlPanelType,
  UpdateQueryType,
} from 'components/types/FilterTypes';
import Icons from 'components/atoms/Icons';

type ControlTogglesProps = {
  searchType: string;
  updateControlPanel: SetControlPanelType;
  viewMode?: string;
  onQueryInputChange: OnQueryInputChangeType;
  queryInputValue: string;
  updateQuery: UpdateQueryType;
  sort: string;
  updateSort: (sort: string) => void;
  withOrigin: boolean;
  selectedFilters: ProviderFiltersType | LocationFiltersType;
  setViewMode?: (mode: string) => void;
  openDesktopControls?: (control?: string) => void;
  clearAllFilters?: () => void;
  selectedFacetsCount: number;
};

const ControlToggles = (props: ControlTogglesProps) => {
  const { updateControlPanel, selectedFacetsCount } = props;

  return (
    <div className="control-toggles">
      <div className="mob-filter-wrapper filter-sidebar">
        <div className="mob-filter">
          <button
            className={`mob-filter-button`}
            aria-label="Open filters"
            onClick={() => updateControlPanel('filters')}
          >
            <Icons id="icon-filters"></Icons>
            {selectedFacetsCount > 0
              ? `Filters (${selectedFacetsCount})`
              : 'Filters'}
            <Icons id="pld-chevron-right" className="chevron-right"></Icons>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ControlToggles;
